import { useMemo } from "react";
import { mixed, number, object, string } from "yup";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.AccountHolderName]: string()
                .required()
                .label('Account Holder Name'),
            [FormField.BankName]: string()
                .required()
                .label('Bank Name'),
            [FormField.Iban]: string()
                .required()
                .label('IBAN')
                .matches(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/, 'Invalid IBAN format'),
            [FormField.ProofFileKey]: mixed()
                .required()
                .label('Proof of Bank Account Ownership'),
            [FormField.Swift]: string()
                .label('SWIFT/BIC')
                .matches(/^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/, 'Invalid SWIFT/BIC format'),
            [FormField.Currency]: string()
                .required()
                .nullable()
                .label('Currency'),
            [FormField.AvgTransactionSize]: number()
                .required()
                .label('Average Transaction Size'),
            [FormField.MonthlyIncome]: number()
                .required()
                .label('Monthly Income'),
            [FormField.TransactionVolume]: number()
                .required()
                .label('Monthly Transaction Volume'),
        })
    ), []);

export default useValidationSchema;
